
import { Storage } from '@ionic/storage';

export const storage = new Storage();

let storageReady: Promise<Storage> | null = null;

export function setupIonicStorage() {
  if (!storageReady) {
    storageReady = storage.create();
  }
  return storageReady;
}
